/* eslint-disable space-before-function-paren */
/* eslint-disable comma-dangle */
/* eslint-disable quotes */
import React from "react";
import PageHeader from "../common/PageHeader";
import { propertyColumns } from "../../constants/MockData";
import GridTable from "../common/Table/Table";
import "./style.less";
import { apiBatchRequest } from "../../utils/api_service";
import { API_URL } from "../../constants/api";
import { Tooltip, IconButton } from "@material-ui/core";
import Visibility from "@material-ui/icons/Visibility";
import PageFilter from "../common/PageFilter";
import { controlType } from "../../constants/common";
import { ShowToast, toastType } from "../../utils/toast-service";
import commonLabels from "../../constants/messageConstants";
import {
  applyFilterOnData,
  IsSectionVisible,
  removeDuplicates,
  UpdateColumnWithConfiguration,
  useQuery,
  IsAutoRunPagesEnabled
} from "../../utils/helper";
import PropertyInfo from "./PropertyInfo";
import _ from "lodash";
import { SECTIONS } from "../../constants/appConstants";
import { NavLink } from 'react-router-dom';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import EditIcon from '@material-ui/icons/Edit';
import PageLandingMessage from '../common/PageLandingMessage/PageLandingMessage';

class Property extends React.PureComponent {
  //constructor to define initial state
  constructor(props) {
    super(props);
    this.state = {
      propertyData: [],
      responsePropertyData: [],
      propertyTypeMasterData: [],
      propertyMasterData: [],
      marketMasterData: [],
      departmentMasterData: [],
      selectedPropertyType: "",
      selectedMarketType: "",
      selectedPropertyId: undefined,
      detailView: false,
      selectedPropertyData: [],
      clientListingMasterData: [],
      propertySubTypeData: [],
      fromMarket: false,
      selectedLegalEntityId: undefined,
      isAutoRunEnabled: IsAutoRunPagesEnabled(),
      isSubmitButtonClicked: false
    };
  }

  // Event: ComponentDidMount, used to load data before mounting of components
  componentDidMount() {
    this.loadData();
  }

  // Function is used to get master data to fill filters and Property Master data
  loadData = () => {
    const currentPage = window.location.href;
    if (currentPage.includes('market') && currentPage.includes('type')) {
      this.setState({
        fromMarket: true
      });
    }
    const query = useQuery();
    this._asyncRequest = apiBatchRequest([      
      {
        url: API_URL.Property.GetPropertyTypeMasterData,
        key: "propertyTypeData",
      },
      {
        url: API_URL.Property.GetPropertyMasterData,
        key: "propertyMasterData",
      },
      {
        url: API_URL.Market.GetMarketMasterdata,
        key: "marketMasterData",
      },
      {
        url: API_URL.Employee.GetDepartmentMasterData,
        key: "departmentMasterData",
      },
      {
        url: API_URL.Transition.GetClientListingData,
        key: 'clientListingMasterData',
      },
      {        
        url: `${API_URL.Transition.GetTransitionData}?showInActivePTF=false`,
        key: 'transitionData',
      },
      {
        url: API_URL.Property.GetPropertySubType,
        key: 'propertySubTypeData'
      }
    ])
      .then(
        ({          
          propertyTypeData,
          propertyMasterData,
          marketMasterData,
          departmentMasterData,
          clientListingMasterData,
          transitionData,
          propertySubTypeData
        }) => {
          this._asyncRequest = null;
          if (propertyTypeData.success === true) {
            const market = query.get('market');
            const type = query.get('type');
            const id = query.get('id');
            const selectedData = [];
            if (market && market !== '') {
              selectedData.push({ key: 'marketName', selected: (marketMasterData.data || []).filter(x => x.marketId === parseInt(market)) });
            }
            if (type && type !== '') {
              if (type.toLowerCase() === 'Employee'.toLowerCase()) {
                selectedData.push({ isComaSeprated: true, key: 'departmentName', selected: (departmentMasterData.data || []).filter(x => x.departmentId === parseInt(id)) });
              } else {
                selectedData.push({ key: 'propertyTypeName', selected: (propertyTypeData.data || []).filter(x => x.propertyTypeId === parseInt(id)) });
              }
            }

            const uniqueAssignmentData = removeDuplicates(transitionData?.data?.map(x => {
              return { assignmentId: x.assignmentId, assignmentName: x.assignmentName };
            }), 'assignmentName') || [];

            let legalEntityData = [];
            uniqueAssignmentData.forEach(x => {
              legalEntityData.push({
                legalEntitiyId: x.assignmentId,
                legalEntity: x.assignmentName
              });
            });
            this.setState({              
              propertyMasterData: propertyMasterData.data || [],
              propertyTypeMasterData: propertyTypeData.data || [],
              marketMasterData: marketMasterData.data || [],
              departmentMasterData: departmentMasterData.data || [],
              selectedMarketType: market,
              selectedPropertyType: type,
              defaultSelectedData: _.cloneDeep(selectedData),
              selectedData: selectedData,
              clientListingMasterData: clientListingMasterData.data,
              legalEntityData,
              propertySubTypeData: propertySubTypeData.data || [],
            }, () => {
              if(this.state.isAutoRunEnabled || this.state.isSubmitButtonClicked || this.props.renderAsChild){
                this.getPropertyData(selectedData);
              }
            });            
          } else {
            ShowToast(
              commonLabels.somethingWrong,
              toastType.ERROR,
              5000,
              500,
              "Server error"
            );
          }
        }
      )
      .catch(() => {
        this._asyncRequest = null;
      });
  }

  // static method just called before render method. It takes updated props and the current state as arguments.
  static getDerivedStateFromProps(newProps, state) {
    if ((((newProps || {}).location || {}).navProps || {}).reload !== (state || {}).reload) {      
      return {
        p: '',
        reload: (((newProps || {}).location || {}).navProps || {}).reload,
        detailView: false,
        selectedPropertyId: undefined,
        selectedLegalEntityId: undefined
      };
    }
  }

  // Method called when component get destroyed or unmount from the DOM
  componentWillUnmount() {
    if (this._asyncRequest) {
      // this._asyncRequest.cancel();
    }
  }

  // Render action buttons like Edit, View into the column for every record based on conditions
  renderActionColumn = (cellInfo) => {
    const selectedPropertyData = [];
    selectedPropertyData.push(cellInfo);

    return (
      <>
        {IsSectionVisible(SECTIONS.PROPERTIES, 0, SECTIONS.VIEW)
          ? <Tooltip title="View">
            <IconButton
              aria-label={"refreshData"}
              size="small"
              onClick={() => {
                this.setState({ detailView: true, selectedPropertyId: cellInfo.propertyId, selectedLegalEntityId: cellInfo.legalEntityId, selectedPropertyData, Editable: false });
              }}
            >
              <Visibility fontSize="small" size="small" />
            </IconButton>
          </Tooltip>
          : ' '}
        {IsSectionVisible(SECTIONS.PROPERTIES, 0, SECTIONS.ADD_EDIT) && !cellInfo.isFreezed
          ? <Tooltip title="Edit">
            <IconButton
              aria-label={"refreshData"}
              size="small"
              onClick={() => {
                this.setState({ detailView: true, selectedPropertyId: cellInfo.propertyId, selectedLegalEntityId: cellInfo.legalEntityId, selectedPropertyData, Editable: true });
              }}
            >
              <EditIcon fontSize="small" size="small" />
            </IconButton>
          </Tooltip>
          : ' '}
      </>
    );
  };

  // Method is used to get Property records
  getPropertyData = (selectedData) => {
    this._asyncRequest = apiBatchRequest([
      {
        url: API_URL.Property.GetPropertyData + '?isCallFromPropertyListing=true',
        key: "propertyData",
      },
    ])
      .then(
        ({
          propertyData
        }) => {
          this._asyncRequest = null;
          if (propertyData.success !== true) {
            ShowToast(
              commonLabels.somethingWrong,
              toastType.ERROR,
              5000,
              500,
              'Server error'
            );
          }          
          this.setState({
            propertyData:
              selectedData.length > 0
              ? applyFilterOnData(propertyData.data || [], selectedData)
              : propertyData.data || [],
            responsePropertyData: propertyData.data || [],
            configuration: propertyData.config,
            selectedData: selectedData || [],
            isSubmitButtonClicked: true
          }, () => {
            this.onFilterChange(selectedData);
          });
        }
      )
      .catch(() => {
        this._asyncRequest = null;
      });
  }

  // Method is called when Auto-Run is false. 
  // It resets all the filters when clicked on Reset button and show the message to click on Search button to view data.
  resetPage = (selectedData) => {    
    this.setState({
      responsePropertyData: null,
      propertyData: [],
      isSubmitButtonClicked: false,
      selectedData
    });
  }

  // Event called when data from filters is changed. It filters the records based on selected filter values
  onFilterChange = (selectedData) => {    
    let { responsePropertyData } = this.state;
    if(responsePropertyData === undefined || responsePropertyData === null || (responsePropertyData || []).length === 0 ) {
      this.getPropertyData(selectedData);
    } else {
      const showInActiveObj = (selectedData.find((m) => m.key === 'showInactive'));
      if (showInActiveObj === undefined) {
        responsePropertyData = responsePropertyData.filter(x => x.showInactive);
      } else if (showInActiveObj !== undefined && showInActiveObj.selected !== undefined) {
        if (showInActiveObj.selected[0].showInactive === false) {
          responsePropertyData = responsePropertyData.filter(x => x.showInactive);
        }
      }
      const filteredData = applyFilterOnData(
        [...responsePropertyData],
        selectedData
      );
      this.setState({ propertyData: filteredData, selectedData });
    }
  };

  // Click event of Back button, It will navigate to Property list view from Detail View
  onBackClick = () => {
    this.setState({ detailView: false, selectedPropertyId: undefined, selectedLegalEntityId: undefined }, () => {
      this.loadData();
    });
  };

  // render method to render the components. If will render Proerty Listing as well as Property Detail view based on conditions
  render() {
    const {
      propertyData,
      propertyTypeMasterData,
      propertyMasterData,
      marketMasterData,
      departmentMasterData,
      selectedData,
      configuration,
      detailView,
      selectedPropertyData,
      clientListingMasterData,
      fromMarket,
      legalEntityData,
      propertySubTypeData
    } = this.state;
    return (
      <>
        {detailView && this.state.selectedPropertyId
          ? (
            <>
              <PropertyInfo Editable={this.state.Editable} selectedPropertyId={this.state.selectedPropertyId}
                selectedLegalEntityId={this.state.selectedLegalEntityId} onBackClick={this.onBackClick} propertyData={selectedPropertyData} />
            </>
          )
          : (
            <>
              {fromMarket && (<PageHeader title="Properties"
                actionsConfig={[
                  {
                    icon: (
                      <NavLink
                        to={{
                          pathname: '/markets',                          
                        }}
                        style={{ color: '#FFF', fontSize: 'small' }}>
                        <ArrowBackIcon
                          size="small"
                          className="back-button no-print"
                        />
                      </NavLink>
                    ),                    
                    title: 'Back to Market'
                  }
                ]}></PageHeader>
              )}
              {!fromMarket && (<PageHeader title="Properties"></PageHeader>)}
              {propertyData && (
                <PageFilter
                  autoFilter={false}
                  onFilterChanged={this.onFilterChange}
                  resetPage={(this.state.isAutoRunEnabled || this.props.renderAsChild) ? undefined : this.resetPage}
                  filterAlwaysVisible={this.props.renderAsChild !== true}
                  filterConfig={[
                    {
                      multiple: true,
                      type: controlType.DropDown,
                      source: marketMasterData,
                      key: "marketName",
                      placeholder: "Search Market",
                      title: "Market",
                    },
                    {
                      multiple: true,
                      type: controlType.DropDown,
                      source: propertyTypeMasterData,
                      key: "propertyTypeName",
                      placeholder: "Search Property Type",
                      title: "Property Type",
                    },
                    {
                      multiple: true,
                      type: controlType.DropDown,
                      source: propertySubTypeData,
                      key: "propertySubTypeName",
                      placeholder: "Search Property Sub Type",
                      title: "Property Sub Type",
                    },
                    {
                      multiple: true,
                      type: controlType.DropDown,
                      source: propertyMasterData,
                      key: "propertyName",
                      placeholder: "Search Property",
                      title: "Property Name",
                    },
                    {
                      multiple: true,
                      type: controlType.DropDown,
                      source: (propertyMasterData || []).filter(p => p.streamlinePropertyName !== null),
                      key: "streamlinePropertyName",
                      placeholder: "Search Property",
                      title: "Streamline Property Name",
                    },
                    {
                      multiple: true,
                      type: controlType.DropDown,
                      source: legalEntityData,
                      key: 'legalEntity',
                      placeholder: 'Search Service Type',
                      title: 'Legal Entity / Customer', // 'Assignment Name',
                      isComaSeprated: true
                    },
                    {
                      multiple: true,
                      type: controlType.DropDown,
                      source: departmentMasterData,
                      key: "departmentName",
                      isComaSeprated: true,
                      placeholder: "Search Property Type",
                      title: "Department",
                    },
                    {
                      multiple: true,
                      type: controlType.DropDown,
                      source: clientListingMasterData,
                      key: 'clientName',
                      placeholder: 'Search Client Name',
                      title: 'Client Name',
                    },
                    {
                      type: controlType.Checkbox,
                      key: 'showInactive',
                      placeholder: 'Search Property',
                      title: 'Show InActive Properties'
                    }
                  ]}
                  gridColumn={3}
                  defaultSelectedData={[]}
                  selectedData={selectedData}
                ></PageFilter>
              )}
              {/* If Auto Run is not enabled and buttons not clicked, then show message to click button */}
              {(this.state.isAutoRunEnabled === false && this.state.isSubmitButtonClicked === false) && 
                (propertyData === null || propertyData.length <= 0) &&
                this.props.renderAsChild !== true &&
                (
                  <PageLandingMessage buttonName={'SEARCH'}/>
                )
              }
              {(this.props.renderAsChild || this.state.isAutoRunEnabled === true || (this.state.isAutoRunEnabled === false && this.state.isSubmitButtonClicked === true)) &&
                <div className="row table-list-container">              
                  <GridTable
                    columns={UpdateColumnWithConfiguration(
                      propertyColumns,
                      configuration
                    )}
                    data={propertyData}
                    renderActionColumn={this.renderActionColumn}
                  ></GridTable>                  
                </div>
              }{" "}
            </>)
        }
      </>
    );
  }
}

export default Property;
